import React from 'react';
import IconButton from 'material-ui/IconButton';
import IconViewModule from 'material-ui/svg-icons/action/view-module';
import IconViewList from 'material-ui/svg-icons/editor/format-list-bulleted';

const btnStyle = {
	width: 24,
	height: 24,
	margin: '0 0 0 10px',
	padding: 0,
};
export class ViewTypeSwitcher extends React.Component {
	render() {
		const { value } = this.props;
		const isGrid = value === 'grid';
		return (
			<div className="header-filter--item header-filter--view">
				<IconButton style={btnStyle} onClick={this.handleChange('grid')}>
					<IconViewModule className={`view-type ${isGrid ? ' is_active' : ''}`} />
				</IconButton>
				<IconButton style={btnStyle} onClick={this.handleChange('list')}>
					<IconViewList className={`view-type ${!isGrid ? ' is_active' : ''}`} />
				</IconButton>
			</div>
		);
	}

	handleChange = value => () => {
		const { onValueChange } = this.props;
		onValueChange(value);
	};
}


// WEBPACK FOOTER //
// src/components/media/components/view-type-switcher.component.jsx